module.exports = __webpack_public_path__ + "img/2013-3.440b784b.jpg";